import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SetPinFlow from '../components/SetPinFlow';
import InfoPopup from '../../dashboard/components/InfoPopup';
import { newPinSet } from '../../../assets/svg';
import BackIcon from '../../../assets/svg/backArrow.svg';
import ContentWrapper from '../../../generic-components/ContentWrapper';
import MainContent from '../../../generic-components/Layout/MainContent';
import AppLayout from '../../../generic-components/Layout';
import { CARD_ACTION_LOGIC_ENUMS, CHANGE_PIN_STYLES_TEXTS } from '../constants';
import {
  canSetPin,
  getMostRelevantCard,
} from '../../../helpers/cardStatus.helper';
import { validateFeatureFlag } from '../../../services/featureFlagService';
import { VIEWS_MAP } from '../../../router/constants';
import { useStore } from '../../../store';

const ChangePin = () => {
  const personalAccount = useStore((state) => state.getPersonalAccount());
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [showSuccessPopup, setShowSuccessPopup] = useState<boolean>(false);
  const cardData = getMostRelevantCard(personalAccount.cards);
  const location = useLocation();
  const backDestination = location.state?.backDestination;
  useEffect(() => {
    if (
      !canSetPin(cardData)
      || !validateFeatureFlag(CARD_ACTION_LOGIC_ENUMS.ACTIONS.SET_PIN)
    ) {
      navigate(`/${backDestination || VIEWS_MAP.LILI_CARD}`);
    }
  }, []);

  return (
    <AppLayout
      assetPath={BackIcon}
      backButtonStyle={CHANGE_PIN_STYLES_TEXTS.BACK_BUTTON}
      backButtonId={CHANGE_PIN_STYLES_TEXTS.BACK_BUTTON_ID}
      backDestination={0}
      layoutStyle={CHANGE_PIN_STYLES_TEXTS.LAYOUT}
      navBarStyle={CHANGE_PIN_STYLES_TEXTS.NAV_BAR}
      title={t(CHANGE_PIN_STYLES_TEXTS.PAGE_TITLE)}
      titleStyle={CHANGE_PIN_STYLES_TEXTS.PAGE_TITLE_STYLE}
      handleNavigate={() => {
        navigate(`/${backDestination || VIEWS_MAP.LILI_CARD}`);
      }}
    >
      <ContentWrapper>
        <MainContent className={CHANGE_PIN_STYLES_TEXTS.MAIN_CONTENT}>
          <div className={CHANGE_PIN_STYLES_TEXTS.WRAPPER}>
            <SetPinFlow
              setShowSuccessPopup={() => {
                setShowSuccessPopup(true);
              }}
            />
            {showSuccessPopup && (
              <InfoPopup
                popupHeight={CHANGE_PIN_STYLES_TEXTS.POPUP_HEIGHT}
                className={CHANGE_PIN_STYLES_TEXTS.POPUP_CLASS_NAME}
                flexParams={CHANGE_PIN_STYLES_TEXTS.POPUP_FLEX_PARAMS}
                handleState={() => {
                  setShowSuccessPopup(false);
                }}
                pictureSrc={newPinSet}
                pictureClassName={CHANGE_PIN_STYLES_TEXTS.POPUP_PICTURE}
                showInfoPopup={showSuccessPopup}
                mainButtonText={t(CHANGE_PIN_STYLES_TEXTS.MAIN_BUTTON_TEXT)}
                mainButtonClassName={
                  CHANGE_PIN_STYLES_TEXTS.MAIN_BUTTON_CLASS_NAME
                }
                buttonClassName={CHANGE_PIN_STYLES_TEXTS.BUTTON_CLASS_NAME}
                text={t(CHANGE_PIN_STYLES_TEXTS.POPUP_TEXT)}
                textClassName={CHANGE_PIN_STYLES_TEXTS.POPUP_TEXT_CLASS_NAME}
                titleClassName={CHANGE_PIN_STYLES_TEXTS.POPUP_TITLE_CLASS_NAME}
                title={t(CHANGE_PIN_STYLES_TEXTS.POPUP_TITLE)}
                additionalCallback={() => {
                  navigate('/my-lili-card');
                }}
              />
            )}
          </div>
        </MainContent>
      </ContentWrapper>
    </AppLayout>
  );
};

export default ChangePin;
